import {EntidadeNextGenService} from "./EntidadeNextGenService";

export class EtiquetaService extends EntidadeNextGenService {

	constructor() {
		super("/etiquetas");
	}

}
